import { z } from "zod";

export const formSchema = z.object({
    title: z.string().min(1, "forms.general-validation.title_required"),
    description: z.string().optional(),
});

export type CommissionGroupEditFormData = z.infer<typeof formSchema>;
